import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function JourneyCompleted() {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 py-10 text-center">
      <div className="text-6xl">🌟</div>
      <h1 className="mt-4 font-[Fredoka] text-3xl font-semibold text-[#3b2a4a]">
        Matinée magique terminée !
      </h1>
      <p className="mt-3 text-sm text-[#5b4b6b]">
        Neo et Lyria sont très fiers de vous. À demain pour une nouvelle aventure.
      </p>

      <div className="mt-8 grid w-full gap-3 rounded-3xl bg-white/70 p-5 text-left text-sm text-[#3b2a4a] shadow-sm backdrop-blur">
        <p>✨ 5 missions accomplies</p>
        <p>🦊 Neo et 🦋 Lyria t'ont accompagné</p>
        <p>💛 Bilan envoyé — merci !</p>
      </div>

      <Link to="/setup" className="mt-8 w-full">
        <Button className="w-full rounded-full bg-[#ff8a65] py-6 text-base font-semibold text-white shadow-lg hover:bg-[#ff7043]">
          Lancer une nouvelle matinée
        </Button>
      </Link>

      <p className="mt-6 text-xs text-[#7a6b8a]">
        Bientôt : journée complète (après-midi + soirée) en version Premium.
      </p>
    </main>
  );
}
